const ITEMS = [
  "Hand-Poured Soy Wax",
  "Small Batches",
  "Beautifully Scented",
  "Made With Intention",
  "Poured in Manayunk",
];

const Marquee = ({ dark = false }) => {
  const row = [...ITEMS, ...ITEMS, ...ITEMS];
  return (
    <div data-testid="editorial-marquee" className={`overflow-hidden border-y ${dark ? "border-white/10 bg-ink" : "border-line bg-white"} py-5`}>
      <div className="animate-marquee flex w-max whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className={`flex items-center font-serif text-lg md:text-2xl font-light tracking-wide ${dark ? "text-ivory/80" : "text-ink/80"}`}>
                <span className="px-8">{item}</span>
                <span className={`inline-block h-1.5 w-1.5 rotate-45 ${dark ? "bg-ivory/30" : "bg-ink/25"}`} />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
